import React, { useRef } from 'react'
import { ContainerNps } from './styles';
import { CSSTransition } from 'react-transition-group';


interface IBackdropProps {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
}

const NpsModal: React.FC<IBackdropProps> = ({ children,isOpen, onClose, className }) => {
    const nodeRef = useRef(null)

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={200} classNames="modal__right" unmountOnExit>
            <ContainerNps ref={nodeRef} className={className} onClick={onClose} >
                {children}
            </ContainerNps>
            </CSSTransition>
    )
}

export default NpsModal